export function getConsentPlayfulProbability() {
  const envVariable = process.env.CONSENT_PLAYFUL_PROBABILITY;

  return isNaN(+envVariable) ? 0.5 : +envVariable;
}